import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SEO } from "@/components/SEO";
import { PageFooterNav } from "@/components/landing/PageChrome";
import { MarketFriezeMini } from "@/components/landing/MarketFrieze";

const FAQS = [
  {
    q: "Zafara est-elle gratuite ?",
    a: "Oui, l'application Zafara est totalement gratuite au téléchargement et à l'utilisation, sur iOS comme sur Android. Aucun abonnement pour naviguer, contacter un vendeur ou déposer une annonce.",
  },
  {
    q: "Quels moyens de paiement Zafara accepte-t-elle ?",
    a: "Zafara prend en charge le Mobile Money (MTN MoMo, Moov Money), le paiement à la livraison et les cartes bancaires. Toutes les transactions sont sécurisées.",
  },
  {
    q: "Dans quelles villes du Bénin Zafara fonctionne-t-elle ?",
    a: "Zafara est disponible dans tout le Bénin, avec une couverture prioritaire sur Cotonou, Porto-Novo, Parakou, Abomey-Calavi et Bohicon. Le service s'étend progressivement à l'ensemble du territoire.",
  },
  {
    q: "Comment devenir vendeur ou livreur indépendant sur Zafara ?",
    a: "Il suffit de télécharger l'application, créer un compte vendeur ou livreur en quelques minutes, valider votre identité et déposer votre première annonce ou proposer vos courses. Aucune caution, aucun frais fixe.",
  },
  {
    q: "Mes paiements sont-ils sécurisés sur Zafara ?",
    a: "Oui. Zafara utilise des passerelles Mobile Money agréées au Bénin et un système d'avis vérifiés. Vous êtes protégé en cas de litige grâce à notre garantie Achat Protégé.",
  },
  {
    q: "Quand Zafara arrive-t-elle au Togo et au Sénégal ?",
    a: "Zafara est aujourd'hui active au Bénin. L'expansion vers le Togo, le Sénégal, la Côte d'Ivoire, le Burkina Faso et le Niger est prévue dès que la traction locale sera consolidée.",
  },
  {
    q: "Qui édite l'application Zafara ?",
    a: "Zafara est éditée par Whilsco-Digit SARL, un studio produit fondé par Wilson Eric. Contact : i.wilson@whilsco.fr.",
  },
  {
    q: "Comment fonctionne la livraison au Bénin ?",
    a: "La livraison est assurée par un réseau de livreurs indépendants agréés Zafara. Vous suivez votre commande en temps réel dans l'application et payez à la livraison si vous préférez.",
  },
];

export default function PageFAQ() {
  return (
    <>
      <SEO
        title="FAQ"
        description="Toutes les questions fréquentes sur Zafara, la marketplace 100% béninoise : paiement Mobile Money, livraison, vendeurs, sécurité, expansion."
        path="/faq"
      />

      <section id="faq" className="py-24 md:py-32" data-testid="faq-section">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <div className="text-center">
            <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#0E7A3B]">
              Questions fréquentes
            </p>
            <h1 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl text-[#16241B] leading-[1.05] tracking-tighter">
              Vous vous demandez ?
              <br />
              <span className="text-[#0E7A3B]">On répond.</span>
            </h1>
            <MarketFriezeMini className="mt-7 mx-auto max-w-[220px]" />
            <p className="mt-6 text-lg text-[#16241B]/70 leading-relaxed max-w-2xl mx-auto">
              Zafara, la marketplace 100% béninoise. Achat, vente, paiement
              Mobile Money, livraison au Bénin — voici tout ce qu'il faut savoir.
            </p>
          </div>

          <div className="mt-14 rounded-3xl border border-[#EDE7D9] bg-white overflow-hidden">
            <Accordion type="single" collapsible className="divide-y divide-[#EDE7D9]">
              {FAQS.map((it, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="px-6 md:px-8 border-b-0"
                >
                  <AccordionTrigger className="font-display text-left text-lg font-semibold text-[#16241B] hover:no-underline py-6">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#16241B]/75 text-base leading-relaxed pb-6">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>

      <PageFooterNav
        prev={{ to: "/whilsco-digit", label: "Whilsco-Digit" }}
        next={{ to: "/contact", label: "Contact" }}
      />
    </>
  );
}
